import { NgModule } from '@angular/core';
import { SharedMaterialModule, TruncatedTooltipDirective } from 'core-client/api';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ResponsiveActionMenuComponent } from './components/responsive-action-menu/responsive-action-menu.component';

@NgModule({
  imports: [SharedMaterialModule, ClipboardModule, ResponsiveActionMenuComponent, TruncatedTooltipDirective],
  exports: [SharedMaterialModule, ClipboardModule, ResponsiveActionMenuComponent, TruncatedTooltipDirective]
})
export class SharedModule {}
